import '@/sentry';
import '@/index.css';
import '@alejandro3c/icy-react-ui/dist/icy-react-ui.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToastProvider } from '@alejandro3c/icy-react-ui';
import App from '@/App';
import { AuthProvider } from '@/shared/contexts/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			gcTime: 1000 * 60 * 60 * 24, // 24 hours
			staleTime: 1000 * 60 * 15, // 15 minutos para todas las consultas
			refetchOnWindowFocus: false, // Desactivado por defecto para todas
		},
	},
});

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<ToastProvider position="top-left">
				<AuthProvider>
					<BrowserRouter>
						<App />
					</BrowserRouter>
				</AuthProvider>
			</ToastProvider>
		</QueryClientProvider>
	</React.StrictMode>,
);
